import PQueue from 'p-queue/dist'

export const queue = new PQueue({ concurrency: 15 })

export const QUEUE_PRIORITY = {
  DEFAULT: 0,
  CRITICAL: 10,
}
